import { VisaDocumentModel } from 'api-hooks/visa-document';
import { generateId } from 'common/utils/string';
import React from 'react';

import {
  VisaDocumentFlightFormType,
  VisaDocumentFlightItemFormType,
  VisaDocumentFormType,
  VisaDocumentHotelFormType,
  VisaDocumentHotelItemFormType,
} from '../components/visa-document-form-type';

export function addNewFlight(): VisaDocumentFlightItemFormType {
  return {
    id: undefined,
    customId: generateId(),
    airlineId: '',
    preferenceId: '',
    route: '',
  };
}

export function addNewFlightSchedule(): VisaDocumentFlightFormType {
  return {
    id: undefined,
    name: '',
    description: '',
    items: [addNewFlight()],
  };
}

export function addNewHotel(): VisaDocumentHotelItemFormType {
  return {
    id: undefined,
    customId: generateId(),
    hotelRoomId: '',
    cityTax: '',
    description: '',
  };
}

export function addNewHotels(): VisaDocumentHotelFormType {
  return {
    id: undefined,
    hotelId: '',
    remark: '',
    items: [addNewHotel()],
  };
}

export default function useGetDefaultValues(visaDocument?: VisaDocumentModel) {
  const defaultValues = React.useMemo<VisaDocumentFormType>(() => {
    const visaDocumentFlights: VisaDocumentFlightFormType[] =
      visaDocument?.visaDocumentFlights?.map((flight) => {
        const items: VisaDocumentFlightItemFormType[] = flight.items?.map(
          (f) => {
            return {
              id: f.id,
              customId: generateId(),
              airlineId: f.airline.id || '',
              preferenceId: f.preference.id || '',
              route: f.route || '',
            };
          },
        ) ?? [addNewFlight()];

        return {
          id: flight.id,
          name: flight.name || '',
          description: flight.description || '',
          items,
        };
      }) ?? [addNewFlightSchedule()];

    const visaDocumentHotels: VisaDocumentHotelFormType[] =
      visaDocument?.visaDocumentHotels?.map((hotel) => {
        const items: VisaDocumentHotelItemFormType[] = hotel.items?.map((h) => {
          return {
            id: h.id,
            customId: generateId(),
            hotelRoomId: h.hotelRoom.id || '',
            cityTax: h.cityTax || '',
            description: h.description || '',
          };
        }) ?? [addNewHotel()];

        return {
          id: hotel.id,
          hotelId: hotel.hotel.id || '',
          remark: hotel.remark || '',
          items,
        };
      }) ?? [addNewHotels()];

    return {
      visaDocument,
      code: visaDocument?.code || '',
      description: visaDocument?.description || '',
      name: visaDocument?.name || '',
      transactionAt: visaDocument?.transactionAt || new Date(),
      price: visaDocument?.price || 0,
      visaDocumentFlights,
      visaDocumentHotels,
    };
  }, [visaDocument]);

  return defaultValues;
}
